import { LOCALE_EN, lsI18nService } from 'ls-vue-common';
import EN from '@/i18n/en-us.json';

const initI18n = () => {
  lsI18nService.init();
  lsI18nService.addLocale(LOCALE_EN, EN);
};

// eslint-disable-next-line import/prefer-default-export
export const lsInternationalizationHelpers = {
  initI18n,
};
